var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.divider,
    style: {
      margin: `${_vm.marginY}px ${_vm.marginX}px`
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }